<template>
	<div class="global-simple-header-container">
		<div class="full-width-header container">
			<div class="logo-cart-row checkout">
				<div class="header-logo-container">
					<a class="header-logo-link" href="javascript:void(0)" @click="openPage('/')">
						<img src="../assets/images/slogo.png" class="header-logo-img"/>
					</a>
				</div>
				<div class="header-label">{{$t('cart.checkout')}}</div>
				<div class="cart-count-wrapper">
					<div class="comp-simple-cart-icon-container">
						<div class="cart-icon-wrapper has-item">
							<a href="javascript:void(0)" @click="openPage('/cart')">
								<span class="cart-img-count-wrapper">
									<img src="../assets/images/cart.svg" class="cart-icon"/>
									<span class="cart-count-container">
										<strong class="hidden-xs">{{$t('common.cart')}}</strong>
										<span>
											<strong class="hidden-xs">(</strong>
											<strong class="cart-count">{{cartNum}}</strong>
											<strong class="hidden-xs">)</strong>
										</span>
									</span>
								</span>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {queryCartQty} from '../api/api.js'
	export default {
		props: {
			isHome:{
				type: Boolean,
				default: false,
			},
			showLogin:{
				type: Boolean,
				default: true,
			},
		},
		data() {
			return {
				isMobile:false,
				showMobileMenu:false,
				showAccountMenu:false,
				cartNum:0,
				lang:'',
				headerCheck:'',
				categoryList:[],
				mobile:'',
				headerTitle:'',
				isLogin:false,
				nickName:''
			};
		},
		created() {
			this.isMobile = this.webIsMobile()
			this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
			var token = localStorage.getItem('token')
			this.isLogin = token ? true : false
			if(this.isLogin){
				this.queryCartQty()
			}
		},
		methods: {
			queryCartQty(){
				var that = this;
				let params = {}
				queryCartQty(params).then(res => {
					if (res.code == 200) {
						that.cartNum = res.data.qty
					}
				})
			},
		}
	}
</script>

<style scoped>
	
</style>